// Header of a printed report page: tournament title and the color legend

import ColorLegend from './ColorLegend';
import OrganizerContacts from './OrganizerContacts';
import { useFirebase } from './FirebaseContextProvider';
import { reportTitle } from '../utils/misc';
import { fadeColorLegend } from '../utils/colorLegend';

export default function GameReportPageTop({ id, colorLegend, newPage }) {
  const { tournamentsById } = useFirebase();
  const tournament = tournamentsById.get(id);

  return (
    <>
      <h4 className={'title' + (newPage ? ' new-page' : '')}>
        {reportTitle(tournament)}
      </h4>
      <OrganizerContacts org={tournament?.organizations?.[0]} print />
      <ColorLegend id={id} colorLegend={fadeColorLegend(colorLegend)} />
    </>
  );
}
